// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.map-container__map[data-v-f7e7511a] {\n    height: 600px;\n    width: 100%;\n    overflow: hidden;\n    border-radius: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
